import { VaultDocumentDTO } from "../DTO/vaultDocumentDTO";

export class StoreVaultDocumentRequest{
    public userId!:string;
    public businessId!:string;
    public vaultDocument!:VaultDocumentDTO;
}